import { apiInstance } from 'utils/request'
import parseError from 'helpers/parseServerError'

export const getArcCampaigns = ({ page, search, filters, sorter }) => {
  return apiInstance
    .get(`/arc_campaigns?include=arc_ads,arc_advertiser`, {
      params: {
        filter: {
          search: search ? encodeURIComponent(search) : null,
          ...filters,
        },
        ...sorter,
        page: {
          number: page,
          size: 20,
        }
      },
      headers: {
        'Accept': 'application/vnd.api+json',
      }
    })
    .catch((error) => {
      parseError(error, 'Cannot get arc campaigns')
    })
}

export const getArcCampaign = (id) => {
  return apiInstance
    .get(`/arc_campaigns/${id}?include=arc_ads,arc_advertiser`, {
      headers: {
        'Accept': 'application/vnd.api+json',
      },
    })
    .catch((error) => {
      parseError(error, 'Cannot get arc campaign')
    })
}

export const createArcCampaign = (data) => {
  return apiInstance
    .post('/arc_campaigns', data, {
      headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .catch((error) => {
      parseError(error, 'Cannot create arc campaign')
    })
}

export const updateArcCampaign = ({ id, data }) => {
  return apiInstance
    .patch(`/arc_campaigns/${id}`, data, {
      headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .catch((error) => {
      parseError(error, 'Cannot update arc campaign')
    })
}

export const deleteArcCampaign = (id) => {
  return apiInstance
    .delete(`/arc_campaigns/${id}`, {
      headers: {
        'Accept': 'application/vnd.api+json',
      },
    })
    .catch((error) => {
      parseError(error, 'Cannot delete arc campaign')
    })
}